/**
 * Dashboard copy — edit freely.
 */
export const dashboardContent = {
  title: "Compare geographies",
  intro:
    "Add counties or communities from the map or search bar. Charts show per-capita rates so different geographic levels compare fairly. Totals below show the crash counts and costs behind those rates.",
  searchPlaceholder: "Search counties and places…",
  emptySelection: "Select a geography on the map or search above to compare.",
  contextHeading: "Totals behind the rates",
  chartsHeading: "Rate comparison",
  mapFiltersNote: "Charts use the same date, crash type, and pedestrian/cyclist filters as the map.",
};
